import { render, staticRenderFns } from "./CheckinsDetail.vue?vue&type=template&id=7f4f36c2"
import script from "./CheckinsDetail.vue?vue&type=script&lang=js"
export * from "./CheckinsDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports